import { render, staticRenderFns } from "./RelationshipToOtherParty.vue?vue&type=template&id=1f0dd486"
import script from "./RelationshipToOtherParty.vue?vue&type=script&lang=ts"
export * from "./RelationshipToOtherParty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports